import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <PublicLayout>
      <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mb-6">
          <XCircle className="w-8 h-8" />
        </div>
        <h1 className="font-heading font-bold text-3xl">Compra cancel·lada</h1>
        <p className="text-muted-foreground mt-3">No s'ha fet cap càrrec al teu compte.</p>
        <Button asChild size="lg" className="rounded-full mt-8">
          <Link to="/targeta-regal">Tornar a intentar-ho</Link>
        </Button>
      </div>
    </PublicLayout>
  );
}
